import { UserDetails } from '@coach-bot/data-access/shared/models';
import { getChromeProfileEmail } from '@shared/extension/utils/chrome-profile';
import { setSentryUser } from '@shared/sentry';
import { Services } from '../services';
import { getStudyReelEmail } from './get-study-reel-email';

export async function updateProfileEmail(services: Services, email: string): Promise<void> {
  const profileEmail: string =
    (await getStudyReelEmail(services.environment.studyReelUrl)) ||
    email ||
    services.environment.userEmail ||
    (await getChromeProfileEmail());
  await services.commonStore.setProfileEmail(profileEmail);
  setSentryUser(profileEmail);
  const userDetails: UserDetails | null =
    await services.initialUserDetailsService.getUserDetailsByEmailWithRetry(profileEmail);
  await services.commonStore.setUserDetails(userDetails);
}
